//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    onComplete: {
      type: Function,
      required: true
    },
    onError: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      stripe: null,
      card: null
    };
  },
  watch: {
    "$root.vueApp.stateUpdatedAt": function $rootVueAppStateUpdatedAt(val, oldVal) {
      this.onComplete(this.stripe, this.card);
    }
  },
  mounted: function mounted() {
    this.stripe = Stripe(this.spec.publicKey);
    var elements = this.stripe.elements();
    var style = {
      base: {
        fontSize: "16px",
        color: "#32325d"
      }
    };
    this.card = elements.create("card", {
      style: style
    });
    this.card.mount(this.$refs.container);

    this._registerEvent();
  },
  methods: {
    _registerEvent: function _registerEvent() {
      var _this = this;

      this.card.addEventListener("change", function (event) {
        var error = event.error;

        if (error) {
          _this.onError(error.message);
        } else {
          _this.onError("");
        }

        if (event.complete) {
          _this.onComplete(_this.stripe, _this.card);
        }
      });
    }
  }
};